import React, { FC } from 'react'
import styled from 'styled-components'
import { Alert, AlertTitle } from '@mui/material'
import { SerializedError } from '@reduxjs/toolkit'
import { FetchBaseQueryError } from '@reduxjs/toolkit/dist/query'

type Props = {
  error?: SerializedError | FetchBaseQueryError
}

export const ModelNotDeployedWarning: FC<Props> = ({ error }) => {
  const fetchError = error as FetchBaseQueryError
  if (fetchError?.status === 'PARSING_ERROR' && fetchError.originalStatus === 404) {
    return (
      <Container>
        <StyledAlert severity="warning">
          <StyledAlertTitle>Model is not deployed</StyledAlertTitle>
          <Description>
            This knowledge base model was not found on the bot hosting. This usually means the bot
            has not been deployed yet since the model was created. Deploy the bot first to be able
            to manage documents, run queries, and configure the knowledge base.
          </Description>
        </StyledAlert>
      </Container>
    )
  }

  return (
    <Container>
      <StyledAlert severity="error">
        <StyledAlertTitle>Failed to load data</StyledAlertTitle>
        <Description>
          An unexpected error occurred while communicating with the bot hosting. Please try again
          later or contact support if the issue persists.
        </Description>
      </StyledAlert>
    </Container>
  )
}

const Container = styled.div`
  padding: 40px 20px;
  display: flex;
  justify-content: center;
`

const StyledAlert = styled(Alert)`
  max-width: 600px;
  align-items: flex-start;

  .MuiAlert-icon {
    align-self: center;
  }
`

const StyledAlertTitle = styled(AlertTitle)`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
  text-align: left !important;
`

const Description = styled.div`
  font-size: 12px;
  line-height: 1.5;
  text-align: left !important;
`
